
import {
    Facet,
    WithSearch
} from "@elastic/react-search-ui";
import CheckboxFilter from './checkboxFilter'
import DropdownSearch from './dropdownSearch'
import SizeFiliterType from "../Toolbar/SizeFiliter";
import MinMaxFilter from "../Toolbar/MinMaxFilter"

import styles from './advancedFilters.module.css'
import { StringMatcher } from "cypress/types/net-stubbing";

type PageProps = {
    showAdvancedFilters: any,
    filters?: any,
    facets?: any;
    setFilter?: any,
    addFilter?: any,
    location: string,
    defaultRent: number,
    removeFilter: any,
    sizeType: {
        value: string
    },
    sizeTypes: any,
    sizeMeasurementType: any;
    setSizeMeasurementType: any,
    defaultSizeFt: number
    defaultSizeM: number,
    clearFilters: any,
    defaultPrice: number,
    category_code: StringMatcher,
    includeDefaultOptions: boolean,
    forSale?: boolean
};

const NoFiliterAvalible = ({ label, border }) => {
    return (
        <div className={` ${styles.borderTop} ${styles.townOuter}`}>
            <p>{label}</p>
            <section className={`${styles.border} ${styles.noResultsMessage}`}>
                <span className={styles.NotTextSubHeading}>There are currently no options available</span>
            </section>
        </div>
    )
}


const AdvancedFilters = ({ facets, category_code, includeDefaultOptions, showAdvancedFilters, filters, addFilter, setFilter, location, defaultRent = 10, defaultSizeFt, defaultSizeM, removeFilter, sizeType, sizeTypes, setSizeMeasurementType, clearFilters, forSale, defaultPrice, ...props }: PageProps) => {
    return (
        <div className={!showAdvancedFilters ? `${styles.Container} ${styles.hide}` : styles.Container}>

            <div className={`${styles.deskHide} ${styles.paddingx}`}>
                <div className={styles.sizeContainer}>
                    <p>Size</p>
                    <SizeFiliterType
                        sizeTypes={sizeTypes}
                        setSizeMeasurementType={setSizeMeasurementType}
                        removeFilter={removeFilter}
                        setFilter={setFilter}
                        filters={filters}
                        sizeValue={sizeType.value}
                    />


                    <MinMaxFilter
                        field={sizeType.value}
                        facetData={facets[`${sizeType.value}_range`] ? facets[`${sizeType.value}_range`][0].data : []} facetName={`${sizeType.value}_range`} isPrice={false}
                        addFilter={addFilter}
                        filters={filters}
                        setFilter={setFilter}
                        removeFilter={removeFilter} additionalFields={[]} />
                </div>
            </div>
            {forSale && (
                <div className={`${styles.deskHide} ${styles.borderTop} ${styles.paddingx} ${styles.rentContainerOuter}`}>
                    <p>Price</p>
                    <section className={styles.rangeContainer}>
                        <MinMaxFilter
                            field={'price'}
                            facetData={facets[`price_range`] ? facets[`price_range`][0].data : []} facetName={`price_range`} isPrice={false}
                            addFilter={addFilter}
                            filters={filters}
                            setFilter={setFilter}
                            removeFilter={removeFilter} additionalFields={[]} />
                    </section>
                </div>
            )}

            {!forSale && (
                <div className={`${styles.deskHide} ${styles.borderTop} ${styles.paddingx} ${styles.rentContainerOuter}`}>
                    <p>Rent</p>
                    <section className={styles.rangeContainer}>
                        <MinMaxFilter
                            field={'rent_pa'}
                            facetData={facets[`rent_pa_range`] ? facets[`rent_pa_range`][0].data : []} facetName={`rent_pa_range`} isPrice={false}
                            addFilter={addFilter}
                            filters={filters}
                            setFilter={setFilter}
                            removeFilter={removeFilter} additionalFields={[]} />
                    </section>
                </div>
            )}
            {facets['town.name'] && facets['town.name'][0].data.length > 0 && (
                <div className={` ${styles.borderTop} ${styles.townOuter}`}>
                    <p>Filter by towns</p>
                    <section className={`${styles.border} ${styles.selectDropdownExternal}`}>
                        <Facet field='town.name' label='Town' isFilterable={true} show={100} view={(props) => {
                            return <DropdownSearch lableLookUp={""} border={false} location={location} {...props} />
                        }} />
                    </section>
                </div>
            )}
            {facets['town.name'] && facets['town.name'][0].data.length === 0 && (
                <NoFiliterAvalible label='Town' border={true} />
            )}
            {facets['availability'] && facets['availability'][0].data.length === 0 && (
                <NoFiliterAvalible label="Availability" border={true} />
            )}

            <Facet field="availability" label="Availability" view={(props) => {
                return <CheckboxFilter {...props} field='availability' setFilter={setFilter} border={true} location={location} includeUiOption={category_code === 'ALL'} defaultOptions={['To Let', 'Under Offer', 'For Sale']} />
            }} />


            {facets['category_code'] && facets['category_code'][0].data.length === 0 && (
                <NoFiliterAvalible label='Type' border={true} />
            )}

            <Facet field='category_code' label='Type' view={(props) => {
                return <CheckboxFilter {...props} field='category_code' setFilter={setFilter} border={true} location={location} lableLookUp={'FILTER_CATEGORIES_'} includeUiOption={category_code !== 'ALL'} />
            }} />


        </div>
    );
}


const AdvancedFiltersWithSearch = ({ ...props }: PageProps) => {
    return <WithSearch mapContextToProps={({ filters, clearFilters, addFilter, setFilter, removeFilter, facets, ...rest }) => ({
        filters, addFilter, setFilter, facets, rest, ...props
    })}>
        {(props) => {
            return <AdvancedFilters {...props} />
        }}
    </WithSearch>
}

export default AdvancedFiltersWithSearch;
